module.exports = __webpack_public_path__ + "static/fonts/iconfont.345d7a68.woff";